import React from 'react';
import parse from 'html-react-parser';

interface Props {
    text: string;
}

const ParseHTML: React.FC<Props> = ({ text }) => {
    return <>{parse(text)}</>
};
 
export default ParseHTML;